import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const JavascriptEditorAndroid: React.FC = () => (
  <SEOLandingPage
    title="JavaScript Editor for Android — JS & React IDE on Mobile | Cosmovex"
    metaDescription="JavaScript Editor — React IDE for Android. Write, run, and preview JavaScript and React code on your phone. ES6+, npm-style imports, live preview, offline support."
    ogTitle="JavaScript Editor for Android — JS & React IDE"
    h1="JavaScript Editor for Android"
    intro="A real JavaScript editor on Android. Write modern ES6+ JavaScript and React components, run them instantly, and preview the output — all from your phone."
    paragraphs={[
      "JavaScript is the language of the web, and JavaScript Editor — React IDE brings that world to Android. It's a code editor built specifically for JS and React developers who want to write, test, and iterate without being tied to a laptop.",
      "The editor understands JavaScript deeply — it supports ES6+ syntax including arrow functions, destructuring, async/await, template literals, and modules. React JSX is fully supported, letting you write and preview components the way you would in a desktop IDE.",
      "One of the most practical features is npm-style import support. You can import popular libraries like lodash, moment, or axios using familiar syntax, and the editor resolves them from a bundled registry. This means you can test real-world code patterns, not just toy examples.",
      "The app includes a live preview panel for HTML/CSS/JS output, making it genuinely useful for front-end work. Write a React component, see it render. Adjust the CSS, see the change. The feedback loop is fast enough that you can actually get work done on mobile.",
    ]}
    features={[
      "ES6+ JavaScript with full syntax support",
      "React JSX editor and component preview",
      "npm-style import resolution for popular libraries",
      "Live HTML/CSS/JS preview panel",
      "Async/await and Promise support",
      "Multi-file project management",
      "Syntax highlighting and error detection",
      "Works offline — no build server needed",
      "Code snippets for common patterns",
      "Dark theme optimized for mobile screens",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.jsreact"
    icon="/images/jsvedit.png"
    appName="JavaScript Editor — React IDE"
    accentColor="#A8720E"
    canonicalPath="/javascript-editor-android"
  />
);

export default JavascriptEditorAndroid;
